export default "__VITE_ASSET__Dx8g9iYs__"